module.exports = __webpack_public_path__ + "3f1e8177514b76f3bd2f4a880f7236c8.svg";